import type { Provider } from '@angular/core';
import type { BaseFacadeContext } from '@kerberos-compliance/compliance-shared-ui';
import { BASE_FACADE_CONTEXT } from '@kerberos-compliance/compliance-shared-ui';
import { AuthStore } from '@/auth/store/auth.store';

/**
 * Provides the BASE_FACADE_CONTEXT for AML Desk.
 *
 * **Organization Handling**:
 * - AML Desk users can switch organizations via the sidebar
 * - The `organizationId` signal from AuthStore actively changes when users switch
 * - When the organization changes, all facades automatically refetch their data
 *
 * **Pagination Config**:
 * - initialPage: 1 (1-indexed pagination)
 * - pageSize: 20 (default page size)
 *
 * @returns {Provider} Provider configuration for BASE_FACADE_CONTEXT
 * @example
 * // In app.config.ts
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideBaseFacadeContext(),
 *     // ... other providers
 *   ],
 * };
 */
export function provideBaseFacadeContext(): Provider {
  return {
    provide: BASE_FACADE_CONTEXT,
    useFactory: (authStore: AuthStore): BaseFacadeContext => ({
      // Active organization signal - changes when user switches orgs
      organizationId: authStore.organizationId,

      // Pagination configuration
      pagination: {
        initialPage: 1,
        pageSize: 20,
      },
    }),
    deps: [AuthStore],
  };
}
